import React, { useEffect, useState } from "react";
import { Toast, ToastContainer } from "react-bootstrap";
import useNetworkStatus from "../hooks/useNetworkStatus";

const NetworkBanner = () => {
  const isOnline = useNetworkStatus();
  const [show, setShow] = useState(false);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    if (!isOnline) {
      setShow(true);
      setWasOffline(true);
    } else if (wasOffline) {
      // briefly show "back online" then hide
      setShow(true);
      const t = setTimeout(() => setShow(false), 3000);
      return () => clearTimeout(t);
    }
  }, [isOnline]);

  if (!show) return null;

  return (
    <ToastContainer position="top-center" className="p-3" style={{ zIndex: 9999 }}>
      <Toast
        show={show}
        onClose={() => setShow(false)}
        bg={isOnline ? "success" : "danger"}
        autohide={isOnline}
        delay={3000}>
        <Toast.Body className="text-white d-flex align-items-center gap-2" style={{ fontSize: "0.85rem", fontWeight: 600 }}>
          <span style={{ fontSize: "1rem" }}>{isOnline ? "✓" : "⚠"}</span>
          {isOnline
            ? "You're back online."
            : "No internet connection. Please check your network."}
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default NetworkBanner;
